import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationBloc } from '@kbloc';
import { EnvironmentVariablesService } from '@kenv';
import { Product } from '@ktypes/enums';
import { NavItemType } from '@ktypes/models';

@Component({
  selector: 'kp-core-nav',
  templateUrl: './core-nav.component.html',
  styleUrls: ['./core-nav.component.scss'],
})
export class CoreNavComponent {
  @Input() quickActionsOpen = false;
  @Output() quickActionsToggled = new EventEmitter<boolean>();
  navItemType = NavItemType;
  product = Product;
  constructor(public navBloc: NavigationBloc, public environmentVariablesService: EnvironmentVariablesService) {}
}
